// Вставить константу в текст
export const insertText = (text, value, start, end) => {
  if (start || end) {
    return text.slice(0, start) + value + text.slice(end);
  } else {
    return text + value;
  }
};
